import { TruncatedText } from '@noor/ui';
import {
  requestEntityName,
  requestParentName,
  requestSku,
  type ChangeRequest,
  type ModerationEntityType,
  type Translate,
} from '@/entities/moderation';

interface EntityCellProps {
  entityType: ModerationEntityType;
  request: ChangeRequest;
  t: Translate;
}

/** Entity cell (Figma row): name + SKU / branch sub-line (no raw ids). */
export function EntityCell({ entityType, request, t }: EntityCellProps) {
  const name = requestEntityName(request, '—');
  const subline = entitySubline(entityType, request, t);
  return (
    <div className="min-w-0 leading-snug">
      <TruncatedText text={name} className="block max-w-56 font-normal" />
      {subline !== undefined && (
        <span className="block max-w-56 truncate text-sm text-muted-foreground tabular-nums">
          {subline}
        </span>
      )}
    </div>
  );
}

function entitySubline(
  entityType: ModerationEntityType,
  request: ChangeRequest,
  t: Translate,
): string | undefined {
  if (entityType === 'products') {
    const sku = requestSku(request);
    if (sku) return `${t('table.sku', 'SKU')}: ${sku}`;
  }
  if (entityType === 'promotions') {
    // A promotion's parent is its branch; none means the whole network.
    const branch = requestParentName(request, '');
    return branch !== '' ? `${t('table.branch', 'Филиал')}: ${branch}` : undefined;
  }
  return undefined;
}
